import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import { Button } from '../styles';
import { Input } from '../../../../Form/styles';
import Portal from '../../../../Portal';
import Popup, { PopupTheme } from '../../../../Popup';
import { PopupBody, PopupInputWrapper, PopupInputLabel } from '../styles';
import { duplicateTheme } from '../../../../../containers/Editor/actions';
import { ThemesState } from '../../../../../containers/Editor/reducer';

interface DuplicateThemeProps {
	themeId: string;
	themes: ThemesState;
	dispatch: Dispatch<StoreState>;
	className?: string;
}
const getNewThemeName = (initialName: string, themes: ThemesState): string => {
	const newName = `${initialName}-copy`;
	const usedThemeNames = Object.values(themes).map(({ name }) => name);

	return usedThemeNames.includes(newName)
		? getNewThemeName(newName, themes)
		: newName;
};

const DuplicateTheme = ({ themeId, themes, className, dispatch }: DuplicateThemeProps) => {
	const { name: initialName } = themes[themeId];
	const [name, setName] = React.useState(initialName);
	const [error, setError] = React.useState<string | null>(null);
	const [isPopupDisplayed, setIsPopupDisplayed] = React.useState(false);

	const handleButtonClick = () => {
		setInitialState();
		setIsPopupDisplayed(true);
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setName(e.target.value);
		setError(null);
	};

	const handleConfirm = () => {
		if (!name) {
			return;
		}

		const usedThemeNames = Object.values(themes).map(({ name }) => name);

		if (usedThemeNames.includes(name)) {
			return setError('error.duplicate_theme');
		}

		setIsPopupDisplayed(false);
		dispatch(duplicateTheme(themeId, name));
		setInitialState();
	};

	const setInitialState = () => {
		const newThemeName = getNewThemeName(initialName, themes);
		setName(newThemeName);
		setError(null);
	};

	return (
		<>
			<Button onClick={handleButtonClick}>
				<Translate value="messages.duplicate" />
			</Button>
			<Portal parentNode={document.body}>
				<Popup
					className={`prevent-drag ${className || ''}`}
					isDisplayed={isPopupDisplayed}
					label={I18n.t('messages.duplicate_theme')}
					theme={PopupTheme.DARK}
					isConfirmDisabled={!name || !!error}
					onConfirm={handleConfirm}
					onCancel={() => setIsPopupDisplayed(false)}
				>
					<PopupBody>
						<PopupInputWrapper isError={!!error}>
							<PopupInputLabel value={error || 'messages.theme_name'} />
							<Input
								type="text"
								value={name}
								onChange={handleInputChange}
							/>
						</PopupInputWrapper>
					</PopupBody>
				</Popup>
			</Portal>
		</>
	);
};

export default DuplicateTheme;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/DuplicateTheme/index.tsx